import { router } from '../router'; // router instance is exported from '@/router'
import store from "@/store";

const state = {
  previousNav: null
};

const mutations = {
  setPreviousNav(state, nav) {
    state.previousNav = nav;
  }
};

const getters = {
  previousNav: state => state.previousNav
};

export const nav = {
  namespaced: true,
  state,
  mutations,
  getters
};

// Set up the assigned value for previous route
router.beforeEach((to, from, next) => {
  const previousNav = from.path;
  store.commit('nav/setPreviousNav', previousNav);
  next();
});